import { FilterControl } from './FilterControl'
import { Filter } from './Filter'
import type { Model } from '@/helpers/models/Model'

export class FilterControls<FilterModel extends Model> {
	items: FilterControl<FilterModel>[]

	constructor(items: FilterControl<FilterModel>[] = []) {
		this.items = items
	}

	find(key: string): FilterControl<FilterModel> | undefined {
		return this.items.find((i) => i.key === key)
	}

	defaultFilterFor(key: string): Filter<FilterModel> | undefined {
		const found = this.find(key)
		if (!found) return undefined
		return new Filter({ key: found.key, operator: 'is', updateQuery: found.queryUpdateHandler })
	}
}
